// src/components/FilterDrawer.js
import React from 'react';
import { XCircleIcon, FunnelIcon } from './Icon';

/**
 * Off-canvas filter panel that slides in from the right.
 * Filters apply live (onChange), so there's no separate "Apply" step.
 *
 * Props:
 *   open      boolean — whether the drawer is visible
 *   onClose   () => void
 *   filters   current filter object
 *   onChange  (nextFilters) => void
 *   onReset   () => void
 */
export default function FilterDrawer({ open, onClose, filters, codeNames = [], onChange, onReset }) {
  const set = (k, v) => onChange({ ...filters, [k]: v, page: 1 });

  return (
    <>
      <div className={`drawer-overlay${open ? ' is-open' : ''}`} onClick={onClose} />
      <aside className={`drawer${open ? ' is-open' : ''}`} role="dialog" aria-label="Filters" aria-hidden={!open}>
        <div className="drawer-header">
          <span className="drawer-title"><FunnelIcon size={16} /> Filters</span>
          <button className="drawer-close" onClick={onClose} aria-label="Close filters">×</button>
        </div>

        <div className="drawer-body">
          <div className="drawer-field">
            <label className="fb-label">Search</label>
            <input
              type="text" className="fb-input"
              placeholder="Name / REF / Email / Mobile / PAN / Source / Source Name..."
              value={filters.search || ''}
              onChange={e => set('search', e.target.value)}
            />
          </div>

          <div className="drawer-field">
            <label className="fb-label">Code Name</label>
            <select className="fb-input" value={filters.code_name || ''} onChange={e => set('code_name', e.target.value)}>
              <option value="">All Code Names</option>
              {codeNames.map(cn => <option key={cn} value={cn}>{cn}</option>)}
            </select>
          </div>

          <div className="drawer-field">
            <label className="fb-label">Status</label>
            <select className="fb-input" value={filters.status || ''} onChange={e => set('status', e.target.value)}>
              <option value="">All Status</option>
              <option>Pending</option>
              <option>Reviewed</option>
              <option>Approved</option>
              <option>Rejected</option>
            </select>
          </div>

          <div className="drawer-field">
            <label className="fb-label">BHK Config</label>
            <select className="fb-input" value={filters.bhk || ''} onChange={e => set('bhk', e.target.value)}>
              <option value="">All BHK</option>
              <option>2 BHK</option>
              <option>3 BHK</option>
              <option>4 BHK</option>
            </select>
          </div>
        </div>

        <div className="drawer-footer">
          <button className="fb-reset" onClick={onReset}>
            <XCircleIcon size={14} /> Reset
          </button>
          <button className="btn-primary" onClick={onClose}>Done</button>
        </div>
      </aside>
    </>
  );
}
